import { wellnub } from '../wellnub.api';

export const requestImageUpload = data =>
  wellnub.post('/v1/nutritionist/file/nutriProfile', data);
